import * as pageStyles from "../../styles/internal-page/internal-page.module.scss";

import React, { Fragment } from "react";

import Anchor from "../shared/Anchor";
import Banner from "./Banner";
import CkEditor from "../shared/ckeditor/CkEditor";
import DiaporamaCarrousel from "../shared/carrousels/DiaporamaCarrousel";
import FocusCarrousel from "../shared/carrousels/FocusCarrousel";
import Section from "./Section";
import TabPanel from "../shared/TabPanel";
import clsx from "clsx";
import TestimonieDiapo from "./TestimonieDiapo";

const Content = ({
  elem,
  fullWidth,
  tweets,
  youtubeVideos,
  siteURL,
  lang,
  locale,
}) => {
  let displayLang = "";
  if (lang) {
    displayLang = lang.toLowerCase();
  }
  const elemAnchor = elem?.anchor || null;
  if (elem.__typename === "CmsPortalComponentWidgetBanner") {
    return (
      <div
        className={clsx(
          pageStyles.marginBetweenBlocs,
          pageStyles.GridRootElement
        )}
      >
        <Banner
          fullWidth={fullWidth}
          target={elem.action_target}
          type={elem.action_type}
          content={elem.bannerContent}
          actionLabel={elem.button}
          title={elem.title}
        ></Banner>
      </div>
    );
  }

  if (elem.__typename === "CmsPortalComponentSectionMain") {
    return (
      <div
        className={clsx(
          pageStyles.marginBetweenBlocs,
          pageStyles.GridRootElement
        )}
      >
        <Section
          siteURL={siteURL}
          content={elem.content}
          fullWidth={fullWidth}
          title={elem.title}
          tweets={tweets}
          youtubeVideos={youtubeVideos}
          locale={locale}
          spacing={elem.spacing}
          three_columns={elem.three_columns}
        ></Section>
      </div>
    );
  }
  if (elem.__typename === "CmsPortalComponentTabTab") {
    return (
      <div
        className={pageStyles.marginBetweenBlocs}
        style={{ width: "100%" }}
      >
        <TabPanel tabs={elem.TabPanel}></TabPanel>
      </div>
    );
  }
  if (elem.__typename === "CmsPortalComponentContentText") {
    return (
      <>
        <Anchor anchor={elemAnchor} />
        <CkEditor html={elem.text} lang={displayLang} elemAnchor={elemAnchor}/>
        <div
          className={pageStyles.marginBetweenBlocsCkeditor}
        />
      </>
    );
  }
  if (elem.__typename === "CmsPortalComponentContentTextShared") {
    let tsh = elem.content_shared?.text_shared
    if (tsh && tsh.length > 0) {
      let tshe = elem.content_shared.text_shared[0]
      return (
        <>
          {tshe.anchor && <Anchor anchor={tshe.anchor} />}
          <div
            id={tshe.anchor || undefined}
            className={pageStyles.marginBetweenBlocs}
          >
            <CkEditor html={tshe.text} lang={displayLang} />
          </div>
        </>
      );
    }
    return (
      <>
      </>
    )
  }
  if (elem.__typename === "CmsPortalComponentWidgetQteCarousel") {
    return (
      <TestimonieDiapo content={elem} hasNoTitle/>
    )
  }
  if (elem.__typename === "CmsPortalComponentWidgetCarousel") {
    if (elem.type === "FOCUS")
      return (
        <FocusCarrousel
          id={elem.id}
          items={elem.carousel_item}
          className={pageStyles.marginBetweenBlocs}
        ></FocusCarrousel>
      );
    return (
      <DiaporamaCarrousel
        id={elem.id}
        items={elem.carousel_item}
        className={pageStyles.marginBetweenBlocs}
      />
    );
  }
  return <Fragment></Fragment>;
};

export default Content;
